import React from 'react';
import styles from '../../Dashboard.module.css';

const SplashLoader = () => {
  return (
    <div className={styles['splash-loader']}>
      <div className={styles['splash-loader-content']}>
        <div className={styles['splash-loader-spinner']} />
        <p className={styles['splash-loader-text']}>Loading documents…</p>
      </div>
    </div>
  );
};

export default SplashLoader;
